/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'shpmtcd'
import { ShippingPartnerStatus } from './orderStatus/optionShippingPartners'

class OrderStatus extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  handleClose = () => {
    // eslint-disable-next-line react/destructuring-assignment
    this.props.dispatchClosePopup()
  }

  render() {
    const { showOrderStatus, orderStatus } = this.props
    return (
      <div>
        <Modal
          title='Track Order'
          width={460}
          wrapClassName='vertical-center-modal'
          visible={showOrderStatus}
          footer={null}
          onCancel={() => this.handleClose()}
        >
          <ShippingPartnerStatus {...orderStatus} />
        </Modal>
      </div>
    )
  }
}

OrderStatus.propTypes = {
  showOrderStatus: PropTypes.bool.isRequired,
  orderStatus: PropTypes.shape({
    shipment_provider: PropTypes.string,
    status: PropTypes.string,
    ordered_date: PropTypes.string,
    in_transit_date: PropTypes.string,
    order_id: PropTypes.string,
    delivered_date: PropTypes.string,
  }).isRequired,
  dispatchClosePopup: PropTypes.func.isRequired,
}
export default OrderStatus
